import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import './modal-login.scss';
import { LoginForm } from '@widgets';
import { setModalLoginShowAC } from '@entities';
import { Icon } from '@ui-kit';
import CloseIcon from '@ui-kit/icons/x-gray700.svg';

const ModalLogin = () => {
  const dispatch = useDispatch();
  const ref = useRef();

  useEffect(() => {
    if(ref.current) {
      const mainWrapper = ref.current.parentNode ;
      mainWrapper.style = `overflow-y: hidden;`;
    }
  }, []);

  const onBackgroundClick = (e) => {
    if (e.target.id === 'login-background') {
      window.location.hash = '';
      closeModal();
    }
  };

  const closeModal = () => {
    window.location.hash = '';
    dispatch(setModalLoginShowAC(false));
    const mainWrapper = ref.current.parentNode ;
    mainWrapper.style = '';
  };

  return (
    <div 
      id="login-background" 
      className="login-modal"
      ref={ref}
      onMouseDown={onBackgroundClick}
    >
      <div className="login-modal__wrapper">
          <LoginForm />
          <div className="modal__close" onClick={closeModal}>
            <Icon src={CloseIcon} alt="close" />
          </div>
      </div>
    </div>
  );
};

export default ModalLogin;
